'use client';

import { useBrandStore } from '@/entities/brand/model/use-brand-store';
import { Link } from '@/i18n/navigation';
import { Container, HStack, IconButton } from '@chakra-ui/react';
import { FiSearch } from 'react-icons/fi';
import { GoArrowLeft } from 'react-icons/go';
import BrandSelectMobile from './BrandSelectMobile';

const HeaderFixed = () => {
  const { brand } = useBrandStore();
  return (
    <Container px={2} bg='white'>
      <HStack justify='space-between' py='2'>
        <Link href='/'>
          <IconButton aria-label='Back' variant='ghost' rounded='xl'>
            <GoArrowLeft strokeWidth='0.75' />
          </IconButton>
        </Link>

        <BrandSelectMobile brandName={brand?.name || ''} />

        <Link href={`/brand-search?restaurant=${brand?.id}`}>
          <IconButton aria-label='Search' variant='ghost' rounded='xl'>
            <FiSearch />
          </IconButton>
        </Link>
      </HStack>
    </Container>
  );
};

export default HeaderFixed;
